import type { ReactNode } from "react";

import Button from "~/components/buttons/Button/Button";
import type { ButtonSizeVariants, ButtonThemeVariants } from "~/components/buttons/Button/buttonVariants.ts";
import Tooltip from "~/components/Tooltip";
import type { ActionBlock } from "~/types/actionBlockTypes.ts";

type Props = {
	block: ActionBlock;
	children: ReactNode;
	className?: string;
	onClick: () => void;
	size?: ButtonSizeVariants;
	theme?: ButtonThemeVariants;
};

/** The backend decides whether the user can do the action, so the button has no check of its own. */
export function ActionBlockButton(props: Props) {
	const button = (
		<Button className={props.className}
				disabled={!props.block.allowed}
				onClick={props.onClick}
				size={props.size}
				theme={props.theme}>
			{props.children}
		</Button>
	);

	if (props.block.allowed || !props.block.reason) return button;

	// A disabled button fires no mouse events, so the tooltip sits on a wrapper.
	return (
		<Tooltip text={props.block.reason}
				 width={320}>
			<span>{button}</span>
		</Tooltip>
	);
}
